import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { DaytimesRouter } from '../../../utils/routes/MusicRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function DaytimesLayout() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/daytimes/',
      }}
    >
      <DaytimesRouter />
    </MainContentLayout>
  )
}
